module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#gallery",
      toString: function () {
        return this.url;
      }
    }